export default {
    palette: {
        mode: 'dark',
    },
}